import { getElement } from './dom-selectors';
export const view = {
    onboarding: getElement('view-onboarding'),
    chat: getElement('view-chat'),
    displayQr: getElement('view-display-qr'),
    scan: getElement('view-scan'),
};
export const chat = {
    messages: getElement('chat-messages'),
    history: getElement('chat-history'),
    inputName: getElement('input-name'),
    inputMessage: getElement('input-message'),
};
export const qr = {
    container: getElement('qr-container'),
};
export const scan = {
    error: getElement('scan-error'),
};
export const toast = {
    body: getElement('toast-body'),
    el: getElement('toast'),
};
export const btn = {
    send: getElement('btn-send'),
    scanResponse: getElement('btn-scan-response'),
    showQrFromScan: getElement('btn-show-qr-from-scan'),
    onboardingSend: getElement('btn-onboarding-send'),
    onboardingScan: getElement('btn-onboarding-scan'),
};
